let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aXLoO")).then(() => parcelRequire('4w1Xx'));